<mat-toolbar [class.darkHeader]="community?.dark_header || isDarkMode"
             class="d-flex mat-elevation-z3 flex-space-between navbar main-header">
    @if (this.currentUser?.hijacked) {
        <mat-toolbar-row>
            <div class="hijackBar"><p>You are viewing the Explain Communities platform
                as {{ this.currentUser?.username }} </p>
                <button (click)="logout()" (keyup.enter)="logout()" aria-label="Log Out" mat-mini-fab
                        matTooltip="Log Out">
                    <mat-icon>exit_to_app</mat-icon>
                </button>
            </div>
        </mat-toolbar-row>
    }
    <mat-toolbar-row class="flex-space-between">
        <div class="flex-row align-items-center h-100 gap-10">
            <div>
                @if (companyImg && community?.logo_position == 'left' && !community?.hide_logo_in_navbar) {
                    <button (click)="goToHomeUrl()"
                            aria-label="Feed"
                            class="logoBg logoBtn" mat-icon-button matTooltip="My Feed">
                        <img [src]="companyImg" class="companyImg">
                    </button>
                }
            </div>
            <div class="flex-row tabStyle align-items-end h-100 gap-10">
                <button [appCustomButtonColours]="(community?.dashboard_button_color_hex ?? ((community?.dark_header || isDarkMode)? 'white' : 'black'))"
                        [routerLinkActive]="'tabSelected'" [routerLink]="['/dashboard']"
                        class="smTabletHidden fill-button darkModeControl" disableRipple
                        mat-button>
                    Dashboard
                </button>
                @for (group of subgroups; track group; let i = $index) {
                    <button [appCustomButtonColours]="(group.button_color_hex || community?.dashboard_button_color_hex || ((community?.dark_header || isDarkMode)? 'white' : 'black'))"
                            [appCustomRouterLinkActive]="'tabSelected'"
                            [customCondition]="group.main_feed? isMainFeed : isSubgroupFeed"
                            [dynamicParamForCondition]="group.id"
                            [queryParams]="group.main_feed? null :{ subgroup: group.id }" [routerLink]="['/feed']"
                            [style.font-family]="group.item_header_text_font?.name"
                            class="lgTabletHidden fill-button" disableRipple
                            mat-button>{{ group.name }}
                    </button>
                }
                @if (subgroupsMenuList.length) {
                    <button [appCustomButtonColours]="community?.dashboard_button_color_hex || ((community?.dark_header || isDarkMode)? 'white' : 'black')"
                            [matMenuTriggerFor]="subgroupsMenu"
                            [appCustomRouterLinkActive]="'tabSelected'"
                            [customCondition]="isSubgroupsFeed"
                            [dynamicParamForCondition]="subgroupsMenuList"
                            class="lgTabletHidden fill-button" disableRipple
                            mat-button>
                        Show more
                    </button>
                    <mat-menu #subgroupsMenu="matMenu">
                        @for (group of subgroupsMenuList; track group; let i = $index) {
                            <button
                                    [appCustomButtonColours]="(group.button_color_hex || community?.dashboard_button_color_hex || ((community?.dark_header || isDarkMode)? 'white' : 'black'))"
                                    [appCustomRouterLinkActive]="'subTabSelected'"
                                    [customCondition]="isSubgroupFeed"
                                    [dynamicParamForCondition]="group.id"
                                    [queryParams]="{ subgroup: group.id }"
                                    [routerLink]="['/feed']"
                                    [style.font-family]="group.item_header_text_font?.name"
                                    class="subTabButton"
                                    mat-menu-item>
                                {{ group.name }}
                            </button>
                        }
                    </mat-menu>
                }
            </div>
        </div>
        <div class="d-flex align-items-center">
            <app-header-community-selector class="lgTabletHidden"/>
            @if (!isApp) {
                <app-header-notifications/>
            }
            @if (currentUser) {
                <button (click)="settings()" aria-label="Settings" class="initialBtn"
                        mat-button matTooltip="Profile settings">
                    <div [appUserAvatar]="currentUser" class="initial">
                    </div>
                    <span [style.--darkColor]="community?.navbar_username_text_color_hex_dark"
                          [style.--lightColor]="community?.navbar_username_text_color_hex"
                          class="smTabletHidden usersName">{{ currentUserName }}</span>
                </button>
            }
            @defer () {
                <button #menuOption="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="Menu"
                        (menuOpened)="menuOption.menuOpen" (menuClosed)="menuOption.menuOpen"
                        class="tabletShow show"
                        mat-icon-button matTooltip="More menu items">
                    <i>
                        <svg viewBox="0 0 100 80" width="40" height="40"
                             [@openClose]="menuOption.menuOpen ? 'open' : 'closed'"
                             (@openClose.done)="onAnimationDone(menuOption.menuOpen)" [class.openedBurger]="menuOpen">
                            <rect width="100" height="10" rx="8"></rect>
                            <rect y="30" width="100" height="10" rx="8"></rect>
                            <rect y="60" width="100" height="10" rx="8"></rect>
                        </svg>
                    </i>
                </button>
                <mat-menu #menu="matMenu">
                    <button [routerLink]="['/dashboard']" class="smTabletShow" mat-menu-item>
                        Dashboard
                    </button>
                    @if (!community?.hide_main_feed_in_navbar) {
                        <button [routerLink]="['/feed']" class="smTabletShow" mat-menu-item>
                            {{ community?.main_feed_name ? community?.main_feed_name : 'Main Feed' }}
                        </button>
                    }
                    <app-header-community-selector class="tabletShow"/>
                    @if (allSubgroups.length > 0) {
                        <button [matMenuTriggerFor]="subGroupsMenuMobile" class="d-flex tabletShow"
                                mat-menu-item>
                            <span>Subgroups</span>
                        </button>
                    }
                    <button (click)="settings()" mat-menu-item>
                        <span>My settings</span>
                    </button>
                    <a routerLink="/account-deletion" mat-menu-item>Delete account</a>
                    @if (isMobile) {
                        <button (click)="openProfile()" mat-menu-item>
                            <span>My profile</span>
                        </button>
                        <button (click)="openRecentActivity()" mat-menu-item>
                            <span>Recent activity</span>
                        </button>
                        @if (community?.show_points) {
                            <button (click)="openPointsLeaderboard()" mat-menu-item>
                                <span>Points leaderboard</span>
                            </button>
                        }
                    }
                    @if (community?.badges_active && hasCommunityRole(['member'])) {
                        <button (click)="openBadges()"
                                mat-menu-item>
                            <span>Badges</span>
                        </button>
                    }
                    @if (community?.levels_active && hasCommunityRole(['member'])) {
                        <button (click)="openLevels()"
                                mat-menu-item>
                            <span>Levels</span>
                        </button>
                    }
                    @if (community?.terms_and_conditions) {
                        <button [routerLink]="['/terms-and-conditions']" mat-menu-item>
                            <span>Terms & conditions</span>
                        </button>
                    }
                    @if (community?.privacy_policy) {
                        <button [routerLink]="['/privacy-policy']" mat-menu-item>
                            <span>Privacy policy</span>
                        </button>
                    }
                    <button [routerLink]="['/contact']" mat-menu-item>
                        <span>Contact us</span>
                    </button>
                    @for (item of listItems; track item) {
                        <button [routerLink]="['/info', item.id]" mat-menu-item>
                            {{ item.title }}
                        </button>
                    }
                    <button [routerLink]="['/communicationPreferences']" mat-menu-item>
                        <span>Communication preferences</span>
                    </button>
                    <button [routerLink]="['/child-endangerment-policy']" mat-menu-item>
                        <span>Child Endangerment Policy</span>
                    </button>
                    @if ((isSuperuser || hasCommunityRole(['full_admin'])) && !isApp) {
                        <button [routerLink]="['/admin']"
                                mat-menu-item>
                              <span [style.color]="community?.admin_panel_button_highlight_color_hex"
                                    class="accent-color">Admin panel</span>
                        </button>
                    }
                    @if (hasCommunityRole(['reports_only'])) {
                        <button [routerLink]="['/reports']" mat-menu-item>
                            Reports
                        </button>
                    }
                    <button (click)="logout()" mat-menu-item>
                        <mat-icon>exit_to_app</mat-icon>
                        <span>Log out</span>
                    </button>
                </mat-menu>
            }

            @if (companyImg && community?.logo_position == 'right') {
                <button (click)="goToHomeUrl()"
                        aria-label="Feed"
                        class="logoBg" mat-icon-button matTooltip="My feed">
                    <img [src]="companyImg" class="companyImg">
                </button>
            }
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<mat-menu #subGroupsMenuMobile="matMenu">
    @for (group of allSubgroups; track group; let i = $index) {
        <button [queryParams]="{ subgroup: group.id }"
                [routerLink]="['/feed']"
                [style.font-family]="group.item_header_text_font?.name" mat-menu-item>
            {{ group.name }} {{ group.item_header_text_font?.name }}
        </button>
    }
</mat-menu>
